import { useState, useEffect } from 'react'
import api from '../lib/api'

export default function Anulaciones() {
  const [tenants, setTenants] = useState([])
  const [selected, setSelected] = useState('')
  const [anulaciones, setAnulaciones] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    api.get('/tenants?per_page=100').then(({ data }) => setTenants(data.data ?? []))
  }, [])

  const fetch = (tenantId) => {
    if (!tenantId) return
    setLoading(true)
    api.get(`/tenants/${tenantId}/dtes`, { params: { per_page: 50 } })
      .then(({ data }) => setAnulaciones(data.data ?? []))
      .finally(() => setLoading(false))
  }

  const handleSelect = (e) => {
    setSelected(e.target.value)
    fetch(e.target.value)
  }

  return (
    <>
      <div className="topbar">
        <div className="breadcrumb"><strong>Anulaciones</strong> — Todos los tenants</div>
        <div className="topbar-actions">
          <select className="form-input" style={{ height: '34px', fontSize: '12px', width: '220px' }} value={selected} onChange={handleSelect}>
            <option value="">— Selecciona un tenant —</option>
            {tenants.map(t => <option key={t.id} value={t.id}>{t.company_name}</option>)}
          </select>
        </div>
      </div>
      <div className="content">
        {!selected && (
          <div className="info-banner">Selecciona un tenant para ver sus anulaciones.</div>
        )}
        {selected && (
          <div className="table-wrap">
            <table>
              <thead><tr><th>Tipo</th><th>Código</th><th>Estado</th><th>Fecha</th></tr></thead>
              <tbody>
                {loading && <tr><td colSpan={4} style={{ textAlign: 'center', padding: '24px', color: 'var(--muted)' }}>Cargando…</td></tr>}
                {!loading && anulaciones.length === 0 && <tr><td colSpan={4} className="empty">Sin documentos</td></tr>}
                {!loading && anulaciones.map(d => (
                  <tr key={d.id}>
                    <td><span className="dte dte-fcf">{d.tipo_dte}</span></td>
                    <td><span className="mono" style={{ fontSize: '10px' }}>{d.codigo_generacion}</span></td>
                    <td>
                      {{ PROCESADO: <span className="badge badge-ok">Procesado</span>,
                         PENDIENTE: <span className="badge badge-warn">Pendiente</span>,
                         RECHAZADO: <span className="badge badge-err">Rechazado</span>,
                      }[d.estado] ?? <span className="badge badge-neutral">{d.estado}</span>}
                    </td>
                    <td style={{ color: 'var(--muted)', fontSize: '11px' }}>{new Date(d.created_at).toLocaleString('es-SV')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  )
}
